import { createContext } from 'react';

export interface IThemeContext {
    /** The theme on screen: the preference, or the OS setting when the preference is `'system'`. */
    theme: ThemeKind;
    preference: ThemePreference;
    cyclePreference: () => void;
}

export enum ThemeKind {
    Dark = 'dark',
    Light = 'light',
}

/** A theme the reader picked with the toggle, or `'system'` to follow the OS setting. */
export type ThemePreference = ThemeKind | 'system';

const contextStub: IThemeContext = {
    theme: ThemeKind.Light,
    preference: 'system',
    cyclePreference: () => {
        // stub
    },
};

const ThemeContext = createContext<IThemeContext>(contextStub);

export default ThemeContext;
